import { apiClient } from "../../../lib/axios";
import {
  ProgrammeSummaryResponse,
  DeliveryPerformanceResponse,
  PhaseCountResponse,
  RisksResponse,
  MonthlySpendTrendResponse,
  VarianceAnalysisResponse,
} from "./types";

export const programmeDashboardApi = {
  fetchProgrammeSummary: async (portfolio_id?: string): Promise<ProgrammeSummaryResponse> => {
    const response = await apiClient.get("/projects/programme-summary", {
      params: { portfolio_id },
    });
    return response.data;
  },

  fetchDeliveryPerformance: async (portfolio_id?: string): Promise<DeliveryPerformanceResponse> => {
    const response = await apiClient.get("/portfolios/delivery-performance", {
      params: { portfolio_id },
    });
    return response.data;
  },

  fetchPhaseCounts: async (portfolio_id?: string): Promise<PhaseCountResponse> => {
    const response = await apiClient.get("/phases/counts", {
      params: { portfolio_id },
    });
    return response.data;
  },

  fetchRisks: async (params: {
    page?: number;
    limit?: number;
    sort_field?: string;
    sort_order?: string;
    category?: string;
    status?: string;
    portfolio_id?: string;
  }): Promise<RisksResponse> => {
    const response = await apiClient.get("/risks", { params });
    return response.data;
  },

  fetchMonthlySpendTrend: async (portfolio_id?: string): Promise<MonthlySpendTrendResponse> => {
    const response = await apiClient.get("/portfolios/monthly-spend-trend", {
      params: { portfolio_id },
    });
    return response.data;
  },

  fetchVarianceAnalysis: async (portfolio_id?: string): Promise<VarianceAnalysisResponse> => {
    const response = await apiClient.get("/projects/variance", {
      params: { portfolio_id },
    });
    return response.data;
  },
};